import { mapActions } from "vuex";

export default {
    methods: {
        ...mapActions({
            saveAll: 'crudStore/saveAll',
        }),
        async actualizarForm() {

        },
        async saveForm(event) {
            try {
                if (event.ftn !== undefined) {
                    switch (event.ftn) {
                        case 'btn0':

                            await this.updateGlobal({
                                state: 'openModal/modal',
                                data: { value: true, title: 'Registrar Aporte', modal: this.nameSearchs, loaded: false }
                            })
                            return true

                            break
                        case 'afiliadoFtn':
                            this.getBackendData = true
                            let totalAfl = 0
                            let servicios_nuevos = this.deepCopy(this.dataForm[this.namePath].servicios_nuevos)
                            await this.resetDataForm({ state: 'servicios_activos' })

                            for (let i = 0; i < this.dataMultiple[this.namePath].multiple_servicios.length; i++) {
                                if (this.dataMultiple[this.namePath].multiple_servicios[i].check === 1) {
                                    let newValue = this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])

                                    if (newValue.id === null) {
                                        let dataAdmin = _.filter(servicios_nuevos, ['name', newValue.name])
                                        if (newValue.id_afiliacion_registro === null) {
                                            if (dataAdmin.length > 0) {
                                                newValue.id_afiliacion_registro = dataAdmin[0].id_afiliacion_registro
                                            } else {
                                                newValue.id_afiliacion_registro = _.filter(this.dataMultiple[this.namePath].multiple_servicios, ['name', 'Administración'])[0].id_afiliacion_registro
                                            }
                                        }
                                        if (newValue.id_info_ingresos === null) {
                                            if (dataAdmin.length > 0) {
                                                newValue.id_info_ingresos = dataAdmin[0].id_info_ingresos
                                            } else {
                                                newValue.id_afiliacion_registro = _.filter(this.dataMultiple[this.namePath].multiple_servicios, ['name', 'Administración'])[0].id_afiliacion_registro
                                            }
                                        }
                                    }
                                    totalAfl = totalAfl + this.dataMultiple[this.namePath].multiple_servicios[i].valor
                                    this.pushDataForm({ state: 'servicios_activos', data: newValue })
                                }
                            }
                            let aporteRegistrado = await this.getData({ route: 'get_aporteregistrado', data: { razon: this.dataForm[this.namePath].info_afiliacion.id_datos_razon, afiliado: this.dataForm[this.namePath].datos_afiliado.id, mes: this.mesPeriodo.id, ano: this.anoPeriodo.id } })

                            var name = this.dataForm[this.namePath].datos_afiliado.nombre1 + ' ' + this.dataForm[this.namePath].datos_afiliado.nombre2 + ' ' + this.dataForm[this.namePath].datos_afiliado.apellido1 + ' ' + this.dataForm[this.namePath].datos_afiliado.apellido2
                            var re = /null/gi;

                            await this.updateDataForm({ state: 'datos_afiliado/name', data: name.replace(re, ' ') })

                            if (aporteRegistrado.archivo_plano === null) {
                                await this.updateGlobal({
                                    state: 'openModal/modal',
                                    data: { value: true, title: 'Registrar Aporte', modal: 'Aportes', loaded: false, data: { novedad: this.novedad, mes_periodo: this.mesPeriodo.id, ano_periodo: this.anoPeriodo.id } }
                                })
                            } else {
                                this.showAporteRegistrado = true
                                this.linkaporte = this.url + '/api/pdf/registroaportes?id=' + aporteRegistrado.archivo_plano.id_info_aportes.toString() + '&token=' + this.token

                            }
                            this.getBackendData = false
                            this.continuarCapa = false
                            return true
                            break
                        case 'aportesFtn':
                            let aporteRegistrados = await this.getData({ route: 'get_aporteregistrado', data: { razon: this.dataForm[this.namePath].info_afiliacion.id_datos_razon, afiliado: this.dataForm[this.namePath].datos_afiliado.id, mes: this.mesPeriodo.id, ano: this.anoPeriodo.id } })

                            if (aporteRegistrados.archivo_plano === null) {
                                if (this.dataForm[this.namePath].descuentos_referido !== null) {
                                    if (this.dataForm[this.namePath].notas_pendientes !== null) {
                                        await this.updateDataPost({
                                            data: {
                                                data: [],
                                                tablaPost: ['info_aportes', 'datos_afiliado', 'info_afiliacion', 'aportes_registro', 'archivo_plano', 'servicios_activos', 'descuentos_referido', 'notas_pendientes'],
                                                tablaDelete: ['notas_pendientes'],
                                                tablaAuditar: true,
                                                route: 'save_all'
                                            }
                                        })
                                    } else {
                                        await this.updateDataPost({
                                            data: {
                                                data: [],
                                                tablaPost: ['info_aportes', 'datos_afiliado', 'info_afiliacion', 'aportes_registro', 'archivo_plano', 'servicios_activos', 'descuentos_referido'],
                                                tablaDelete: [],
                                                tablaAuditar: true,
                                                route: 'save_all'
                                            }
                                        })
                                    }
                                } else {
                                    if (this.dataForm[this.namePath].notas_pendientes !== null) {
                                        await this.updateDataPost({
                                            data: {
                                                data: [],
                                                tablaPost: ['info_aportes', 'datos_afiliado', 'info_afiliacion', 'aportes_registro', 'archivo_plano', 'servicios_activos', 'notas_pendientes'],
                                                tablaDelete: ['notas_pendientes'],
                                                tablaAuditar: true,
                                                route: 'save_all'
                                            }
                                        })
                                    } else {
                                        await this.updateDataPost({
                                            data: {
                                                data: [],
                                                tablaPost: ['info_aportes', 'datos_afiliado', 'info_afiliacion', 'aportes_registro', 'archivo_plano', 'servicios_activos'],
                                                tablaDelete: [],
                                                tablaAuditar: true,
                                                route: 'save_all'
                                            }
                                        })

                                    }
                                }
                            } else {
                                this.limpiarSearchs()
                                this.resetGlobal({ state: 'openModal' })
                                await this.saveNotify(true, 'Ya existe un aporte registrado en este periodo para el afiliado ' + this.dataForm[this.namePath].datos_afiliado.name + ' debes hacer el proceso de nuevo.')
                                return true
                            }
                            break
                        case 'aportesGrupalFtn':
                            await this.updateDataPost({ state: 'tablaPost', data: ['info_aportes', 'datos_afiliado', 'info_afiliacion', 'aportes_registro', 'archivo_plano', 'servicios_activos', 'notas_pendientes'] })
                            await this.updateDataPost({ state: 'tablaDelete', data: ['notas_pendientes'] })
                            await this.updateDataPost({ state: 'route', data: 'save_all' })
                            event.savePost = true
                            break
                        case 'editarAportesFtn':
                            await this.updateDataPost({ state: 'tablaPost', data: ['datos_afiliado', 'info_afiliacion', 'servicios_activos'] })
                            await this.updateDataPost({ state: 'tablaDelete', data: [] })
                            await this.updateDataPost({ state: 'route', data: 'save_all' })
                            break
                    }
                }

                let dataSave = await this.save(event.save, event.savePost)

                if (dataSave.error === false) {
                    if (event.ftn !== undefined) {
                        switch (event.ftn) {
                            case 'aportesFtn':
                                window.open(this.url + '/api/pdf/registroaportes?id=' + dataSave.ids.info_aportes.toString() + '&token=' + this.token, '_blank')
                                break;
                            case 'aportesGrupalFtn':
                                window.open(this.url + '/api/pdf/registroaportes?id=' + dataSave.ids.info_aportes.toString() + '&token=' + this.token, '_blank')
                                break;
                        }
                    }

                    if (event.ftn !== 'editarAportesFtn') {
                        await this.limpiarSearchs()
                    } else {
                        if (this.nameSearchs === 'AportesCentros') {
                            await this.getDataGet({ route: 'get_centroaporte', data: { id_datos_contacto: this.searchSw.value, mes_periodo: this.mesPeriodo.id, ano_periodo: this.anoPeriodo.id } })
                        }
                        if (this.nameSearchs === 'AportesRazon') {
                            await this.getDataGet({ route: 'get_razonaporte', data: { id_datos_razon: this.searchSw.value, mes_periodo: this.mesPeriodo.id, ano_periodo: this.anoPeriodo.id } })
                        }
                        if (this.nameSearchs === 'AportesAsesor') {
                            await this.getDataGet({ route: 'get_asesoraporte', data: { id_datos_asesor: this.searchSw.value, mes_periodo: this.mesPeriodo.id, ano_periodo: this.anoPeriodo.id } })
                        }
                    }

                    const await01 = this.updateCrud({ state: 'dataMultiple/' + this.namePath + '/multiple_servicios', data: this.predeterminados[this.namePath].multiple_servicios })
                    const await02 = this.resetDataIndex()
                    const await03 = this.resetGlobal({ state: 'openModal' })
                    const await04 = this.resetGlobal({ state: 'saveConfig/capa' })
                    const await05 = this.resetDataForm()
                    const await06 = this.onInit()

                    await Promise.all([await01, await02, await03, await04, await05, await06])

                    return true
                } else {
                    const await00 = this.resetGlobal({ state: 'saveConfig/capa' })
                    const await01 = this.resetDataPost({ state: 'data' })
                    await Promise.all([await00, await01])
                }
            } catch (e) {
                console.log('error save aportes registro', e)

            }
        }
    },
}